export const StatusType = {
  DRAFT: 'draft',
  LIVE: 'live',
}
